import React, { createContext, useContext, useState } from 'react';

type ServiceType = string | null;

interface ServiceContextType {
  selectedService: ServiceType;
  setSelectedService: (service: ServiceType) => void;
}

const ServiceContext = createContext<ServiceContextType>({
  selectedService: null,
  setSelectedService: () => {},
});

export const useService = () => useContext(ServiceContext);

export const ServiceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedService, setSelectedService] = useState<ServiceType>(null);

  return (
    <ServiceContext.Provider value={{ selectedService, setSelectedService }}>
      {children}
    </ServiceContext.Provider>
  );
};